import {typeExport} from "../../../../../redux/store/type";


const reducerGalleryServiceScreen = (state = {
  empty: false,
    failed: false,
    lazyload_end: false,
    NoInternetDialog: false, page:1,
    results: [],
    showLoading: false,
    showRefresh: false,

    isLoadingSet: false,
    NoInternetDialogSet: false,
    resultsSet: null,
    notif: false,
    id: 0,
    ListFilter: []
}, action) => {
    const newState = {...state};
    switch (action.type) {
        case typeExport.GalleryServiceScreen_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialog: false,
                showLoading: true,
                showRefresh: false,
                failed: false,
                empty: false,
                lazyload_end: false,

            };
        case typeExport.GalleryServiceScreen_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialog: action.page === 1 ? true : false,
                showLoading: false,
                showRefresh: false,
                failed: action.page === 1 ? false : true,
                lazyload_end: true,
                empty: false,
                page: action.page
            };
        case typeExport.GalleryServiceScreen_SERVICE_SUCCESS:
            return {
                ...state,
                results: action.page === 2 ? action.results : [...state.results, ...action.results],
                NoInternetDialog: false,
                showLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: false,
                empty: false,
                page: action.page
            };
        case typeExport.GalleryServiceScreen_SERVICE_END:
            return {
                ...state,
                //results: state.results,
                results: action.page === 2 ? action.results : [...state.results, ...action.results],
                NoInternetDialog: false,
                showLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: true,
                empty: false,
                page: action.page
            };
        case typeExport.GalleryServiceScreen_SERVICE_REFRESH:
            return {
                ...state,
                results: [],
                NoInternetDialog: false,
                showLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: false,
                empty: false,
                page: action.page,
                id: 0,
                //  ListFilter: [],

            };
        case typeExport.GalleryServiceScreen_SERVICE_Empty:
            return {
                ...state,
                results: state.results,
                NoInternetDialog: false,
                showLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: true,
                empty: true,
                page: action.page
            };
        case typeExport.GalleryServiceScreen_SERVICE_ADD_FIRST_DATA:
            return {
                ...state,
                results: action.results,
                NoInternetDialog: false,
                showRefresh: false,
                failed: false,
                lazyload_end: action.lazyload_end,
                showLoading: action.showLoading,
                empty: action.empty,
                page: action.page
            };
        case typeExport.SetGalleryServiceScreen_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialogSet: action.NoInternetDialogSet,
                isLoadingSet: action.isLoadingSet,
                resultsSet: action.resultsSet,
                id: action.id
            };
        case typeExport.SetGalleryServiceScreen_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialogSet: action.NoInternetDialogSet,
                isLoadingSet: action.isLoadingSet,
                error: action.error
            };


        case typeExport.SetGalleryServiceScreen_SERVICE_SUCCESS:

            newState.NoInternetDialogSet = action.NoInternetDialogSet;
            newState.resultsSet = action.resultsSet;
            newState.isLoadingSet = action.isLoadingSet;
            newState.id = 0;
            newState.results =
                newState.results.map((val, key) => {
                    if (val.id === action.id) {
                        val.apply_notify = action.resultsSet.apply_notify;
                        return val;
                    }
                    return val;
                });

            return newState

        case typeExport.GalleryServiceScreen_SERVICE_CHANGE_NOTIF:


            newState.results =
                newState.results.map((val, key) => {
                    if (key === action.index) {
                        val.status = action.data;
                        return val;
                    }
                    return val;
                })

            return newState;
        case typeExport.GalleryServiceScreen_SERVICE_AddSubList:

            return {
                ...state,
                results: action.data,
                showLoading: false,
                lazyload_end: (action.data.length < 10) ? true : false,
            };

        case typeExport.GalleryServiceScreen_SERVICE_LIST_FILTER:

            return {
                ...state,
                ListFilter: action.ListFilter,

            };

        case typeExport.GalleryServiceScreen_SERVICE_SET_LIKE:
            // return update(state, {
            //     results: {
            //         [action.index]: {
            //             like: {$set: action.data}
            //         }
            //     }
            // });


            newState.results =
                newState.results.map((val, key) => {
                    if (key === action.index) {
                        val.like = action.data;
                        if (action.res)
                            val.count_like = action.res.count_like;
                        return val;
                    }
                    return val;
                })

            return newState;

        case typeExport.GalleryServiceScreen_SERVICE_SET_DISPLAY_IMAGE:
            // const some_array = [...this.state.list]
            //
            // some_array[index].slider[indexSwiper].display = !this.state.list[index].slider[indexSwiper].display
            //
            // this.setState({list: some_array}
            //     ,
            //     () => {
            //     }
            // )

            // newState.results =
            //     newState.results[action.index].slider.map((val, key) => {
            //         if (key === action.indexSwiper) {
            //             val.display = action.data;
            //             return val;
            //         }
            //         return val;
            //     })


            newState.results =
                newState.results.map((val, key) => {
                    if (key === action.index) {
                        val.slider.map((val, key) => {
                            if (key === action.indexSwiper) {
                                val.display = action.data;
                                return val;
                            }
                            return val;
                        });
                    }
                    return val;
                })
            // newState.results[action.index].slider.map((val, key) => {
            //     if (key === action.indexSwiper) {
            //         val.display = action.data;
            //         return val;
            //     }
            //     return val;
            // })
            return newState;

        case typeExport.GalleryServiceScreen_SERVICE_SET_DISPLAY_COMMENT:
            // const some_array = [...this.state.list]
            //
            // some_array[index].lastWork[indexWork].display = !this.state.list[index].lastWork[indexWork].display
            //
            // this.setState({list: some_array}
            //     ,
            //     () => {
            //     }
            // )

            newState.results =
                newState.results.map((val, key) => {
                    if (key === action.index) {
                        val.lastWork.map((val, key) => {
                            if (key === action.indexWork) {
                                val.display = action.data;
                                return val;
                            }
                            return val;
                        });
                    }
                    return val;
                })

            return newState;

        case typeExport.GalleryServiceScreen_SERVICE_SET_COMMENT:


            newState.results =
                newState.results.map((val, key) => {
                    if (key === action.index) {
                        val.lastWork.map((val, key) => {
                            if (key === action.indexWork) {
                                val.comment = action.data;
                                return val;
                            }
                            return val;
                        });
                    }
                    return val;
                })
            return newState;


        case typeExport.GalleryServiceScreen_SERVICE_ADD_FILE:
            // return update(state, {
            //     results: {
            //         [action.index]: {
            //             like: {$set: action.data}
            //         }
            //     }
            // });

            // // this.getData()
            // const some_array = [...this.state.list]
            //
            // some_array[index].slider.push({
            //     id: 4,
            //     image: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/1200px-Image_created_with_a_mobile_phone.png",
            //     display: true
            // })
            //
            // this.setState({list: some_array, showModal: false}
            //     ,
            //     () => {

            //     }
            // )
            newState.results =
                newState.results.map((val, key) => {
                    if (key === action.index) {
                        val.slider.push(action.data)
                        return val;
                    }
                    return val;
                })

            return newState;
        default:
            return state;
    }
}

export default reducerGalleryServiceScreen;
